import { type RawApplicationContext } from '@/app/browser/app/init';
import { type ApplicationContextCustom, type IApplicationContext } from '@/app/shared/types/ApplicationContext';

export function createContext(rawApplicationContext: RawApplicationContext): IApplicationContext {
  return {
    ...rawApplicationContext,
    custom: rawApplicationContext.config.getStrict<ApplicationContextCustom>('applicationContext.custom'),
  };
}
